import { useEffect } from "react";
import { useQuery } from "react-query";
import { refreshAccessTokenRequest } from "../../api/auth.requests";
import { QUERY_KEYS } from "../../constants/queries";
import { Authority } from "../providers/AuthProvider";
import { useAuth } from "./useAuth";
import { useAxios } from "./useAxios";
import { useGlobalState } from "./useGlobalState";

export const useRefreshToken = () => {
  const axios = useAxios();
  const { auth, setAuth } = useAuth();
  const { globalState, setGlobalState } = useGlobalState();

  // Refresh token query
  const refreshTokenQuery = useQuery([
    QUERY_KEYS.getRefreshToken,
    auth.refreshToken,
  ], async () => {
    const res = await refreshAccessTokenRequest({
      axios,
      refreshToken: auth.refreshToken,
      tenantId: auth.tenantId,
    });

    // @ts-ignore
    const accessToken = `bearer ${res.data.access_token}`;
    // @ts-ignore
    const authorities = res.data.authorities.map(
      (item: any) => item.authority,
    ) as Authority[];
    setAuth({
      // @ts-ignore
      accessToken,
      authorities,
    });
    setGlobalState({
      hasFetchedRefreshToken: true,
    });

    return res.data;
  }, {
    enabled: !globalState.hasFetchedRefreshToken,
  });

  // TODO: the following doesn't work, find out why
  // useEffect(() => {
  //   console.log("setting new access token");
  //   // @ts-ignore
  //   const accessToken = `bearer ${res.data.access_token}`;
  //   // @ts-ignore
  //   const authorities = res.data.authorities.map(
  //     (item: any) => item.authority,
  //   ) as Authority[];
  //   setAuth({
  //     // @ts-ignore
  //     accessToken,
  //     authorities,
  //   });
  //   setGlobalState({
  //     hasFetchedRefreshToken: true,
  //   });
  // }, [refreshTokenQuery.data]);

  useEffect(() => {
    // console.log("global fetched");
    // console.log(globalState.hasFetchedRefreshToken);
  }, [globalState.hasFetchedRefreshToken]);
  return refreshTokenQuery;
};
